import { Container } from 'react-bootstrap';
import React from 'react';

import SEO from '@/components/common/SEO';

import FeedbackForm from './FeedbackForm';

import './FeedbackPage.css';

export default function FeedbackPage() {
    const handleSuccess = () => {
        // Optionally navigate somewhere after successful submission
        // For now, the success message in the form is sufficient
    };

    return (
        <>
            <SEO
                title="Feedback"
                description="Share your feedback to help improve the Sustainability Hub."
                breadcrumbs={[
                    { name: 'Home', path: '/' },
                    { name: 'Feedback', path: '/feedback' },
                ]}
            />
            <div id="feedback-page" className="page-container">
                <Container className="form-container">
                    <FeedbackForm onSuccess={handleSuccess} />
                </Container>
            </div>
        </>
    );
}
